import { resolver, singleton, instance } from './di';
import { OptionalitySpec, OptionSpec, DutchAuctionSpec, FaucetSpec } from 'optionality';
import web3 from './web3';
import account from './account-service';
import network from './network-service';
import contract from './contract';
import pairs from './pairs-service';
import dates from './dates-service';
import prices from './prices-service';
import strikes from './strikes-service';
import token from './token-service';
import timer from './timer-service';
import option from './option-service';
import cache from './cache-service';
import serviceFactory from './service-factory';
import log from './log';
import config from './config';
import holdings from './holdings-service';
import auction from './auction-service';
import erc20Contract from './erc20-contract';

if (typeof (window) === 'undefined') {
  var window = global;
}
var fetch = window.fetch || "No fetch in context";

export default resolver({
  web3: singleton(web3),
  pairs: singleton(pairs),
  dates: singleton(dates),
  account: singleton(account),
  network: singleton(network),
  erc20Contract: singleton(erc20Contract),
  optionContract: singleton(contract(OptionSpec)),
  faucetContract: singleton(contract(FaucetSpec)),
  optionality: singleton(contract(OptionalitySpec)),
  auctionContract: singleton(contract(DutchAuctionSpec)),
  prices: singleton(prices),
  strikes: singleton(strikes),
  token: singleton(token),
  timer: singleton(timer),
  serviceFactory: singleton(serviceFactory),
  option: singleton(option),
  cache: singleton(cache),
  holdings: singleton(holdings),
  auction: singleton(auction),

  config: instance(config),
  fetch: instance(fetch),
  window: instance(window),
  log: instance(log)
})


// WEBPACK FOOTER //
// ./src/api/context.js